module.exports = __webpack_public_path__ + "img/dongTa.d03811bd.png";